import React from 'react'

const NewsBody = () => {
  return (
    <div className="news-body">
    </div>
  );
}

export default NewsBody



// WEBPACK FOOTER //
// ./src/components/Home/NewsBody.js